import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { RouteContainer, LoadingOverlay } from "altus-ui-components";

import { ACTIONS } from "features/planner/planner.constants";
import { getActionDataStateFromState } from "app/app.selectors";
import { getSubContractor } from "features/planner/planner.actions";
import { getSubContractorFromState } from "features/planner/planner.selectors";
import EmployeeEarliestNextDeploymentWarning from "features/planner/employee/components/EmployeeEarliestNextDeploymentWarning";

class SubContractorContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, employeeCardId } = this.props;
    dispatchOnLoad(employeeCardId);
  }

  render() {
    const { routes, subContractor, dataState } = this.props;

    return (
      <>
        {subContractor && (
          <EmployeeEarliestNextDeploymentWarning
            employee={subContractor.get("employee")}
          />
        )}
        {subContractor && <RouteContainer routes={routes} />}
        <LoadingOverlay dataState={dataState} />
      </>
    );
  }
}

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      dataState: getActionDataStateFromState(state, ACTIONS.GET_SUB_CONTRACTOR),
      subContractor: getSubContractorFromState(state, employeeCardId),
    }),
    {
      dispatchOnLoad: getSubContractor,
    },
  ),
)(SubContractorContainer);
